module.exports = __webpack_public_path__ + "c32354a1d0bdccbc5921b5bf7134011a.pdf";